// extracted by mini-css-extract-plugin
export default {"aboutme":"Aboutme_aboutme__cOR30","about":"Aboutme_about__oKR6F","Emoji":"Aboutme_Emoji__lIsSq","floating":"Aboutme_floating__0RJCJ"};